import * as React from "react";
const SvgMaxIconbaseline = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8,7 L11,7 L11,17 L13,17 L13,7 L16,7 L12,3 L8,7 Z M4,19 L4,21 L20,21 L20,19 L4,19 Z" }));
export default SvgMaxIconbaseline;
